module.exports = __webpack_public_path__ + "static/media/mmm-header-logo.54b91497.svg";